import config from "@/lib/config";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import routes from "@/lib/routes";
const footer = {
  vod: `
･････････････････････････････････････････････････････････
□このメールアドレスは、配信専用です。
  本メールに返信をいただきましても、ご質問等にはお答えできませんのでご了承ください。

□お問い合わせフォーム
  https://spoox.skyperfectv.co.jp/inquiry

□配信元
  スカパーJSAT株式会社　東京都港区赤坂1-8-1

□SPOOX公式サイト
  https://spoox.skyperfectv.co.jp/
･･････････････････････････････････････････････････････････････････････････････････････
`
};
export function registerPincodeMail(_ref) {
  let {
    address,
    pincode
  } = _ref;
  const maxAge = config.pincode.maxAge / 60;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
本人確認のため、以下の認証コードを入力し会員登録をお願いします。
認証コード：${pincode}
※認証コードの有効期限はお送りしてから${maxAge}分です。
※有効期限が切れた際には再度メールアドレスを入力して再送信してください。

このメールにお心あたりのない場合は、お手数ですが、削除していただきますようお願いいたします。

${footer.vod}
  `
  };
  return {
    address,
    subject: `${serviceName}認証コード送付のお知らせ`,
    body: body["vod"]
  };
}
export function accountEditPincodeMail(_ref2) {
  let {
    address,
    pincode
  } = _ref2;
  const maxAge = config.pincode.maxAge / 60;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
本人確認のため、以下の認証コードを入力し会員情報変更をお願いします。
認証コード：${pincode}
※認証コードの有効期限はお送りしてから${maxAge}分です。
※有効期限が切れた際には再度メールアドレスを入力して再送信してください。

このメールにお心あたりのない場合は、お手数ですが、削除していただきますようお願いいたします。

${footer.vod}
  `
  };
  return {
    address,
    subject: `${serviceName}認証コード送付のお知らせ`,
    body: body["vod"]
  };
}
export function profilePinResetTokenMail(_ref3) {
  let {
    address,
    token
  } = _ref3;
  const maxAge = config.pincode.maxAge / 60;
  const url = `${config.host.vod}${routes.profilePincodeReset}?token=${token}`;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
暗証番号リセットを受付いたしました。
以下URLよりお手続きをお願いいたします。

${url}

URLが発行されてから${maxAge}分以内に登録を完了してください。
URLが無効になった場合は、お手数ですが再度メールアドレスの登録を行ってください。

${footer.vod}
  `
  };
  return {
    address,
    subject: "暗証番号リセットのお知らせ",
    body: body["vod"]
  };
}
export function passwordResetTokenMail(_ref4) {
  let {
    address,
    token
  } = _ref4;
  const maxAge = config.pincode.maxAge / 60;
  const url = `${config.host.vod}${routes.passwordRemindReset}?token=${token}`;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
パスワードリセットを受付いたしました。
以下URLよりお手続きをお願いいたします。

${url}

URLが発行されてから${maxAge}分以内に登録を完了してください。
URLが無効になった場合は、お手数ですが再度メールアドレスの登録を行ってください。

${footer.vod}
  `
  };
  return {
    address,
    subject: "パスワードリセット方法のお知らせ",
    body: body["vod"]
  };
}
export function passwordResetComplete(_ref5) {
  let {
    address
  } = _ref5;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
パスワードリセットが完了いたしました。
ご登録いただいたパスワードでログインしてお楽しみください。

${config.host.vod}${routes.login}

${footer.vod}
  `
  };
  return {
    address,
    subject: "パスワードリセット完了のお知らせ",
    body: body["vod"]
  };
}
export function passwordUpdateComplete(_ref6) {
  let {
    address
  } = _ref6;
  const body = {
    vod: `
    パスワード変更が完了いたしました。
    ご登録いただいたパスワードでログインしてお楽しみください。
    ログイン
    ${config.host.vod}${routes.login}

${footer.vod}
  `
  };
  return {
    address,
    subject: "パスワード変更完了のお知らせ",
    body: body["vod"]
  };
}
export function duplicateAddress(_ref7) {
  let {
    address
  } = _ref7;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
お客様のメールアドレスで会員登録がございました。
お客様は既にご登録済みとなりますのでログイン画面よりログインしてご利用ください。
ログイン
${config.host.vod}${routes.login}

新たに会員登録を希望の場合は、別のメールアドレスにて再度会員登録をお願い致します。

心当たりが無い場合、よくある質問（https://faq.skyperfectv.co.jp/?site_domain=spoox）をご確認いただき、入力いただいたメールアドレスについてご確認をお願いいたします。

${footer.vod}
    `
  };
  return {
    address,
    subject: "メールアドレス認証のお知らせ",
    body: body["vod"]
  };
}
export function accountEditDuplicateAddress(_ref8) {
  let {
    address
  } = _ref8;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
会員情報変更でお客様のメールアドレスが入力されました。
心当たりがない場合は不正アクセスのおそれがありますので、メールアドレスやパスワードの変更をお願い致します。

${footer.vod}
    `
  };
  return {
    address,
    subject: "メールアドレス認証のお知らせ",
    body: body["vod"]
  };
}
export function signupComplete(_ref9) {
  let {
    address,
    user
  } = _ref9;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}の会員登録いただきありがとうございます。
会員登録が完了いたしました。

SPOOX ID：${address}
上記IDとご登録いただいたパスワードにてログインしてお楽しみください。
・ログインはこちら
${config.host.vod}${routes.login}


${footer.vod}
    `
  };
  return {
    address,
    subject: "会員登録完了のお知らせ",
    body: body["vod"]
  };
}
export function myskpSignupComplete(_ref10) {
  let {
    address,
    user
  } = _ref10;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}の会員登録いただきありがとうございます。
会員登録が完了いたしました。

ご入力いただいたMyスカパー！IDまたは以下SPOOX IDにてログインしてお楽しみください。
SPOOX ID：${address}
上記IDとご登録いただいたパスワードにてログインしてお楽しみください。
・ログインはこちら
${config.host.vod}${routes.login}


${footer.vod}
    `
  };
  return {
    address,
    subject: "会員登録完了のお知らせ",
    body: body["vod"]
  };
}
export function userUpdate(_ref11) {
  let {
    address,
    user
  } = _ref11;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
この度は${serviceName}をご利用いただきありがとうございます。
お客様情報の変更が完了いたしました。
変更後の情報はアカウントページよりご確認いただけます。


${footer.vod}
    `
  };
  return {
    address,
    subject: "ご登録情報変更のお知らせ",
    body: body["vod"]
  };
}
export function withdrawalComplete(_ref12) {
  let {
    address,
    user
  } = _ref12;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
${serviceName}のご利用、誠にありがとうございました。
退会が完了いたしました。
またのご利用、心よりお待ちしております。

${footer.vod}
    `
  };
  return {
    address,
    subject: "退会のお知らせ",
    body: body["vod"]
  };
}
export function myskpWithdrawalComplete(_ref13) {
  let {
    address,
    user
  } = _ref13;
  const serviceName = config.serviceName["vod"];
  const body = {
    vod: `
${serviceName}のご利用、誠にありがとうございました。
退会が完了いたしました。
Myスカパー！IDの削除をご希望の場合はMyスカパー！サイトよりお手続きをお願いいたします。

またのご利用、心よりお待ちしております。

${footer.vod}
    `
  };
  return {
    address,
    subject: "退会のお知らせ",
    body: body["vod"]
  };
}
export function addPaymentInstrument(_ref14) {
  let {
    address,
    paymentInstrument
  } = _ref14;
  const paymentMethod = paymentInstrument.payment_method;
  const body = (() => {
    if (paymentMethod.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS) {
      var _paymentInstrument$va;
      const cardNumber = `****-****-****-${paymentInstrument === null || paymentInstrument === void 0 || (_paymentInstrument$va = paymentInstrument.values) === null || _paymentInstrument$va === void 0 ? void 0 : _paymentInstrument$va.card_number}`;
      return `
お支払い情報の登録が完了いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}
クレジットカード番号: ${cardNumber}

${footer["vod"]}
`;
    } else {
      return `
お支払い情報の登録が完了いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}

${footer["vod"]}
`;
    }
  })();
  return {
    address,
    subject: "お支払い情報の登録が完了しました",
    body: body
  };
}
export function changePaymentInstrument(_ref15) {
  let {
    address,
    course,
    paymentInstrument
  } = _ref15;
  const paymentMethod = paymentInstrument.payment_method;
  const body = (() => {
    if (paymentMethod.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS || paymentMethod.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS) {
      var _paymentInstrument$va2;
      const cardNumber = `****-****-****-${paymentInstrument === null || paymentInstrument === void 0 || (_paymentInstrument$va2 = paymentInstrument.values) === null || _paymentInstrument$va2 === void 0 ? void 0 : _paymentInstrument$va2.card_number}`;
      return `
${course.name}のお支払い情報を変更いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}
クレジットカード番号: ${cardNumber}

${footer["vod"]}
`;
    } else {
      return `
${course.name}のお支払い情報を変更いたしました。

■お支払い情報
お支払い情報: ${paymentMethod.name}

${footer["vod"]}
`;
    }
  })();
  return {
    address,
    subject: "お支払い情報の変更が完了しました",
    body: body
  };
}